"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BrandAZBanner;
const react_1 = __importDefault(require("react"));
const BrandAZBanner_module_scss_1 = __importDefault(require("./BrandAZBanner.module.scss"));
const Button_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/button/Button");
const ChevronRightOutlined_1 = require("@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined");
const dispatchAnalytics_1 = require("../../utils/dispatchAnalytics");
function BrandAZBanner({ ctaLink, ctaText, clickUrl, logoImage, mobileImage, tabletImage, desktopImage, impressionUrl, accessibilityText, associatedAdvertId, logoAccessibilityText, esiType, }) {
    return (react_1.default.createElement("div", { id: "brand-az-banner-container" },
        react_1.default.createElement("a", { href: ctaLink, "data-testid": "brand-az-banner-link", onClick: () => {
                (0, dispatchAnalytics_1.dispatchKevelAnalyticsEvent)({
                    action: "kevel.clicked",
                    type: "banner",
                    adId: associatedAdvertId,
                    clickUrl,
                    impressionUrl,
                    esiType,
                });
            }, className: BrandAZBanner_module_scss_1.default.bannerLink },
            react_1.default.createElement("div", { className: BrandAZBanner_module_scss_1.default.container, "data-testid": "brand-az-banner-container" },
                react_1.default.createElement("picture", null,
                    react_1.default.createElement("source", { srcSet: desktopImage, media: "(min-width: 1024px)", "data-testid": "brand-az-banner-src-desktop" }),
                    react_1.default.createElement("source", { srcSet: tabletImage, media: "(min-width: 600px)", "data-testid": "brand-az-banner-src-tablet" }),
                    react_1.default.createElement("img", { src: mobileImage, alt: accessibilityText, className: BrandAZBanner_module_scss_1.default.bannerImage, "data-testid": "brand-az-banner-image" })),
                react_1.default.createElement("img", { className: BrandAZBanner_module_scss_1.default.logo, alt: logoAccessibilityText, src: `${logoImage}?fmt=auto`, "data-testid": "brand-az-banner-logo" }),
                react_1.default.createElement("div", { className: BrandAZBanner_module_scss_1.default.ctaContainer },
                    react_1.default.createElement(Button_1.TertiaryButton, { icon: ChevronRightOutlined_1.ChevronRightOutlined, 
                        // size="small"
                        onClick: () => { }, labelText: ctaText }))))));
}
